import SmartHomeIcon from "@/assets/smarthome.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const SmartHomeLogo = (props: Props) => (
  <LogoImage imgSrc={SmartHomeIcon} alt="Smart Home Logo" size="navbar" {...props} />
);
